import React from 'react';
import Icon from '../../../components/AppIcon';

const FinancialSummary = ({ data }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <div className="mb-6">
        <h2 className="text-lg font-semibold text-gray-900 mb-1">Financial Summary</h2>
        <p className="text-sm text-gray-600">Monthly profit & loss overview</p>
      </div>
      {/* Key Financial Metrics */}
      <div className="grid grid-cols-2 gap-4 mb-6">
        <div className="bg-green-50 rounded-lg p-4">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="DollarSign" className="w-5 h-5 text-green-600" />
            <span className="text-sm font-medium text-gray-600">Revenue</span>
          </div>
          <p className="text-2xl font-bold text-gray-900">${(data?.monthlyRevenue / 1000)?.toFixed(0)}k</p>
        </div>
        
        <div className="bg-red-50 rounded-lg p-4">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="CreditCard" className="w-5 h-5 text-red-600" />
            <span className="text-sm font-medium text-gray-600">Expenses</span>
          </div>
          <p className="text-2xl font-bold text-gray-900">${(data?.monthlyExpenses / 1000)?.toFixed(0)}k</p>
        </div>
      </div>
      {/* Profit Margin */}
      <div className="bg-blue-50 rounded-lg p-4 mb-6">
        <div className="flex items-center justify-between mb-2">
          <div className="flex items-center gap-2">
            <Icon name="TrendingUp" className="w-5 h-5 text-blue-600" />
            <span className="text-sm font-medium text-gray-600">Profit Margin</span>
          </div>
          <span className="text-2xl font-bold text-gray-900">{data?.profitMargin}%</span>
        </div>
        <div className="w-full bg-blue-200 rounded-full h-2">
          <div 
            className="bg-blue-600 h-2 rounded-full transition-all"
            style={{ width: `${data?.profitMargin}%` }}
          />
        </div>
      </div>
      {/* Expense Breakdown */}
      <div className="mb-6">
        <h3 className="text-sm font-semibold text-gray-900 mb-3">Expense Breakdown</h3>
        <div className="space-y-3">
          {data?.expenseBreakdown?.map((expense, index) => (
            <div key={index}>
              <div className="flex items-center justify-between mb-1">
                <span className="text-sm text-gray-700">{expense?.category}</span>
                <span className="text-sm font-semibold text-gray-900">
                  ${expense?.amount?.toLocaleString()} ({expense?.percentage}%)
                </span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-1.5">
                <div 
                  className="bg-primary-600 h-1.5 rounded-full transition-all"
                  style={{ width: `${expense?.percentage}%` }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Financial Alerts */}
      {data?.alerts && data?.alerts?.length > 0 && (
        <div>
          <h3 className="text-sm font-semibold text-gray-900 mb-3">Alerts</h3>
          <div className="space-y-2">
            {data?.alerts?.map((alert, index) => (
              <div 
                key={index}
                className={`flex items-start gap-2 p-3 rounded-lg ${
                  alert?.type === 'warning' ? 'bg-yellow-50 border border-yellow-200' : 'bg-blue-50 border border-blue-200'
                }`}
              >
                <Icon 
                  name={alert?.type === 'warning' ? 'AlertTriangle' : 'Info'} 
                  className={`w-4 h-4 mt-0.5 ${
                    alert?.type === 'warning' ? 'text-yellow-600' : 'text-blue-600'
                  }`}
                />
                <span className="text-sm text-gray-700">{alert?.message}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default FinancialSummary;